import { UpdateEmailTemplateMeta, UpdateEmailTemplatePayload } from 'types/store/UpdateEmailTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { updateEmailTemplateActions } from '../actions';

export default createAsyncReducer<UpdateEmailTemplateMeta, UpdateEmailTemplatePayload>(updateEmailTemplateActions);
